var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"title"},[_vm._t("default"),_c('v-spacer'),_c('v-icon',{staticStyle:{},attrs:{"text":"","color":"#fff"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" mdi-close ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }